export class Util {
    /**
     * Has THIS coupon already been applied to THIS item as many times as the
     * item's quantity? Used to stop a second instance of the same coupon landing
     * on a line that is already fully covered by it.
     *
     * The count is PER ITEM, matching the legacy POS check of the same name: it
     * counts the item's own ItemsCoupons rows whose coupon key belongs to this
     * coupon id, and adds the units marked so far in this qualification pass.
     * It deliberately does NOT count order-wide.
     */
    static CheckSameCouponAppliedQtyTimes(cart, oItem, couponId) {
        const couponKeys = new Set(cart.coupons.filter((c) => c.couponId === couponId).map((c) => c.couponKey));
        const count = cart.itemsCoupons.filter((ic) => ic.itemKey === oItem.itemKey &&
            ic.halfIndex === oItem.halfIndex &&
            ic.itemRecId === oItem.itemRecId &&
            couponKeys.has(ic.couponKey)).length;
        return count + oItem.discountedMarkedQuantity >= oItem.quantity;
    }
    static GetItemPricedModifierCount(item, preModifiers) {
        let mCount = 0;
        for (const mod of item.modifiers) {
            const preMod = preModifiers.find(x => x.preModifierId === mod.preModifierId) || null;
            let preModPriceMultiplier = 1.00;
            if (preMod)
                preModPriceMultiplier = Number(preMod.priceCountMultiplier);
            if (mod.countForPricing || mod.countForPricingByItself)
                mCount += (1 * preModPriceMultiplier);
        }
        return mCount;
    }
    static GetQualifier(coupon, qualifierClass) {
        return coupon._preQualifiers.find((q) => q instanceof qualifierClass);
    }
    /**
    * Rounds a floating point number to 2 decimal places and returns the result.
    * @param {string|number} value - The number to round.
    * @returns {number} - The resulting rounded number.
    */
    static Float2(value) {
        let returnValue = 0.0;
        const num = Util.FloatNum(value);
        returnValue = Util.FloatX(num, 2);
        return returnValue;
    }
    /**
    * Rounds a floating point number to the specified number of decimal places and returns the result.
    * @param {string|number} num - The number to round.
    * @param {number} decimalPlaces - The number of decimal places to round to.
    * @returns {number} - The resulting rounded number.
    */
    static FloatX(num, decimalPlaces) {
        const number = this.FloatRemove_e(Number(num));
        return +(Math.round(Number(number + "e+" + decimalPlaces)) + "e-" + decimalPlaces);
    }
    /**
    * Removes the "e" notation from a floating point number and returns the result as a float.
    * @param {number} value - The value to remove "e" notation from.
    * @returns {number} - The resulting float value.
    */
    static FloatRemove_e(value) {
        let stringValue = parseFloat(value.toFixed(13)) + " ";
        if (stringValue.indexOf("e") === -1) {
            return parseFloat(stringValue);
        }
        for (let i = 13; i > 0; i--) {
            stringValue = parseFloat(value.toFixed(i)) + " ";
            if (stringValue.indexOf("e") === -1) {
                break;
            }
        }
        return parseFloat(stringValue);
    }
    /**
    * Converts a value to a floating point number.
    * @param {string|number} value - The value to convert to a floating point number.
    * @returns {number} - The resulting floating point number, or 0 if the value cannot be converted.
    */
    static FloatNum(value) {
        let num = 0;
        try {
            switch (typeof value) {
                case "string":
                    if (this._checkIsNumber(value)) {
                        num = parseFloat(value);
                    }
                    break;
                case "number":
                    num = value;
                    break;
            }
        }
        catch (ex) {
            console.error('Failed to compute num:', ex);
            num = 0;
        }
        return num;
    }
    /**
    * Checks if the provided value is a number.
    * @param {(string|number)} value - The value to check.
    * @returns {boolean} - Whether the provided value is a number.
    */
    static _checkIsNumber(value) {
        if (typeof (value) == 'number') {
            value = value.toString();
        }
        if (typeof (value) == 'string') {
            if (this._checkMinLength(value, 1)) {
                return !isNaN(Number(value));
            }
            else {
                return false;
            }
        }
        return false;
    }
    /**
    * Checks if the provided value is at least the provided minimum length.
    * @param {*} value - The value to check.
    * @param {number} minLength - The minimum length that the value must be.
    * @returns {boolean} - Whether the provided value is at least the provided minimum length.
    */
    static _checkMinLength(value, minLength) {
        if (value != undefined)
            return (value.length >= minLength);
        else
            return false;
    }
}
//# sourceMappingURL=util.js.map